import { render, staticRenderFns } from "./Notificationshistory.vue?vue&type=template&id=70a53eff&scoped=true"
import script from "./Notificationshistory.vue?vue&type=script&lang=js"
export * from "./Notificationshistory.vue?vue&type=script&lang=js"
import style0 from "./Notificationshistory.vue?vue&type=style&index=0&id=70a53eff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a53eff",
  null
  
)

export default component.exports